import { StepBase } from './StepBase'
import { PageStepType } from './PageTypes';

export class StepSkipIf extends StepBase
{
}